import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  NumberInput,
  NumberInputField,
  Select,
  SimpleGrid,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
  useColorModeValue
} from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import JoditEditor from "jodit-react";
import { CityType } from "models/city_type";
import { ContatoType } from "models/contato_type";
import { OrderType } from "models/order_type";
import { PessoaType } from "models/person_type";
import { ProjectContact } from "models/project_contact_type";
import { OptionType } from "models/select_mode";
import { UsuarioModel } from "models/user_model";
import { useEffect, useRef, useState } from "react";
import { MdAdd, MdEdit, MdSave } from "react-icons/md";
import InputMask from "react-input-mask";
import formatNumber from "views/admin/order/hooks/formatNumber";
interface ILaunchProjectForm {
  showModal: (show: boolean, item: OrderType) => void;
  show: boolean;
  accountSelected: OrderType;
  loading: boolean;
  clients: PessoaType[];
  descricao: string;
  changeInput: (tipo: string, value: any) => void;
  users: UsuarioModel[];
  cidades: CityType[];
  insertCity: CityType;
  changeCity: (tipo: string, value: any) => void;
  addCity: (item: CityType) => void;
  removeCity: (item: CityType) => void;
  editCity: (item: CityType, index: number, tipo: string, valor: any) => void;
  contatoAgencia: ContatoType;
  contatoCliente: ContatoType;
  contatoList: ProjectContact[];
  insertContact: ProjectContact;
  changeContact: (tipo: string, value: any, classificacao: string) => void;
  addContact: (item: ProjectContact) => void;
  removeContact: (item: ProjectContact) => void;
  editContact: (
    item: ProjectContact,
    index: number,
    tipo: string,
    valor: any
  ) => void;
  cityRef: any;
  contactRef: any;
  chageTipo: (classificacao: string) => void;
  usuarios: UsuarioModel[],
  addUser: (userId: string, index: number) => void;
  changeRespFinanceiro: (tipo: string, value: string) => void;
  changeRespJuridico: (tipo: string, value: string) => void;
  save: () => void;
  showFormPessoa: (show: boolean) => void;
  editPessoa: (item: PessoaType) => void;
  changeContrato: (item: string) => void;
  changeFaturamento: (item: string) => void;
  faturamento: PessoaType;
  contrato: PessoaType;
}

const LaunchProjectForm = ({
  show,
  showModal,
  accountSelected,
  clients,
  loading,
  descricao,
  changeInput,
  users,
  cidades,
  insertCity,
  changeCity,
  addCity,
  removeCity,
  editCity,
  contatoAgencia,
  contatoCliente,
  contatoList,
  addContact,
  changeContact,
  editContact,
  insertContact,
  removeContact,
  cityRef,
  contactRef,
  chageTipo,
  addUser,
  usuarios,
  changeRespFinanceiro,
  changeRespJuridico,
  save,
  editPessoa,
  showFormPessoa,
  changeContrato,
  changeFaturamento,
  faturamento,
  contrato
}: ILaunchProjectForm) => {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const mask = "(99) 99999-9999";
  const editor = useRef(null);
  const initialAccountState = {
    custoFixo: 0,
    custoVenda: 0,
    custoProduto: 0,
    lucro: 0,
    custoProdutoLucro: 0,
    precoLiquido: 0,
    imposto: 0,
    descontoValor: accountSelected?.desconto || 0,
    acrescimoValor: accountSelected?.acrescimo || 0,
    comissaoValor: accountSelected?.comissao || 0,
    textoAcrescimo: "0",
    categAcrescimo: accountSelected?.tipoAcrescimo || "",
    textoComissao: "0",
    categComissao: accountSelected?.tipoComissao || "",
    textoDesconto: "0",
    categDesconto: accountSelected?.tipoDesconto || "",
    totalOrder: 0,
  };

  const [accountState, setAccountState] = useState(initialAccountState);



  useEffect(() => {
    const calcula = () => {
      if (accountSelected?.modeloNegocio) {
        const custofixo =
          (accountSelected?.modeloNegocio.custoFixo * accountSelected?.total) /
          100;
        const custovenda =
          (accountSelected?.modeloNegocio?.custoVenda *
            accountSelected?.total) /
          100;
        const totalcustoproduto =
          custofixo + custovenda + Number(accountSelected?.total);
        const lucrovalor =
          (accountSelected?.modeloNegocio?.metaLucro * totalcustoproduto) / 100;
        const custoprodutolucro = totalcustoproduto + lucrovalor;
        const custoprodutoliquido =
          Number(custoprodutolucro) +
          Number(accountState.comissaoValor) +
          Number(accountState.acrescimoValor) -
          Number(accountState.descontoValor);
        const valorImposto =
          (custoprodutoliquido /
            (100 - accountSelected?.modeloNegocio?.imposto)) *
          100 -
          custoprodutoliquido;
        let calculaTotal = custoprodutoliquido + valorImposto;

        setAccountState({
          ...accountState,
          custoFixo: custofixo,
          custoVenda: custovenda,
          custoProduto: totalcustoproduto,
          lucro: lucrovalor,
          custoProdutoLucro: custoprodutolucro,
          precoLiquido: custoprodutoliquido,
          imposto: valorImposto,
          totalOrder: calculaTotal,
        });
      }
    };

    calcula();
  }, [accountSelected, clients]);

  return (
    <Box>
      <Box>
        <Box
        >
          <Box
            px="0px"
            mt="0px"
            justifyContent="space-between"
            ml={4}
          >
            <Stack direction="row" spacing={4}>
              <Button
                leftIcon={<MdSave />}
                colorScheme="brand"
                size={"sm"}
                ml={2}
                variant="solid"
                isLoading={loading}
                onClick={() => {
                  save();
                }}
              >
                Salvar
              </Button>
            </Stack>
          </Box>
        </Box>
        <SimpleGrid column={1} spacing={4} mt={24}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={"black"}
            >
              Contexto do Projeto
            </FormLabel>
            <Textarea
              defaultValue={descricao}
              fontSize="sm"
              height={100}
              ms={{ base: "0px", md: "0px" }}
              placeholder="Preencha o contexto do projeto"
              onBlur={(e) => changeInput("descricao", e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>
        </SimpleGrid>

        <Text
          mt={8}
          fontSize={18}
          color={"#422AFB"}
          fontWeight={"bold"}
          mb={4}
        >
          Dados do projeto
        </Text>

        <SimpleGrid columns={3} spacing={4} mt={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Produtor(a) Broders Responsável
            </FormLabel>

            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size="md"
              placeholder="Busque o Responsável"
              isRequired={true}
              name={"executivo"}
              onChange={(e) => {
                addUser(e.value, 0)
              }}
              options={users?.map((item) => {
                return {
                  label: item.nome,
                  value: item.id,
                };
              })}
              defaultValue={{
                label: usuarios[0]?.id,
                value: usuarios[0]?.nome,
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              E-mail Produtor(a) Broders
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder=" E-mail Produtor(a) Broders"
              fontWeight="500"
              size="md"
              disabled={false}
              value={usuarios[0]?.email}

            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Telefone Produtor(a) Broders
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Telefone Produtor(a) Broders"
              fontWeight="500"
              size="md"
              disabled={false}
              as={InputMask}
              mask={mask}
              value={usuarios[0]?.telefone}
            />
          </FormControl>
        </SimpleGrid>
        <SimpleGrid columns={3} spacing={4} mt={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Executivo(a) Broders Responsável
            </FormLabel>

            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size="md"
              placeholder="Busque o Responsável"
              isRequired={true}
              name={"executivo"}
              onChange={(e) => {
                addUser(e.value, 1)
              }}
              options={users?.map((item) => {
                return {
                  label: item.nome,
                  value: item.id,
                };
              })}
              defaultValue={{
                label: usuarios[1]?.id,
                value: usuarios[1]?.nome,
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              E-mail Executivo(a) Broders
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="E-mail Executivo(a) Broders"
              fontWeight="500"
              size="md"
              disabled={false}
              value={usuarios[1]?.email}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Telefone Executivo(a) Broders
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Telefone Executivo(a) Broders"
              fontWeight="500"
              size="md"
              disabled={false}
              as={InputMask}
              mask={mask}
              value={usuarios[1]?.telefone}
            />
          </FormControl>
        </SimpleGrid>
        <SimpleGrid columns={3} spacing={4} mt={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Diretor(a) de Produção
            </FormLabel>

            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size="md"
              placeholder="Busque o Responsável"
              isRequired={true}
              name={"executivo"}
              onChange={(e) => {
                addUser(e.value, 2)
              }}
              options={users?.map((item) => {
                return {
                  label: item.nome,
                  value: item.id,
                };
              })}
              defaultValue={{
                label: usuarios[2]?.id,
                value: usuarios[2]?.nome,
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              E-mail Diretor(a) de Produção
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="E-mail Diretor(a) de Produção"
              fontWeight="500"
              size="md"
              disabled={false}
              value={usuarios[2]?.email}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Telefone Diretor(a) de Produção
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Telefone Diretor(a) de Produção"
              as={InputMask}
              mask={mask}
              fontWeight="500"
              size="md"
              disabled={false}
              value={usuarios[2]?.telefone}
            />
          </FormControl>
        </SimpleGrid>
        <SimpleGrid columns={3} spacing={4} mt={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Diretor(a) de Cena
            </FormLabel>

            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size="md"
              placeholder="Busque o Responsável"
              isRequired={true}
              name={"executivo"}
              onChange={(e) => {
                addUser(e.value, 3)
              }}
              options={users?.map((item) => {
                return {
                  label: item.nome,
                  value: item.id,
                };
              })}
              defaultValue={{
                label: usuarios[3]?.id,
                value: usuarios[3]?.nome,
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              E-mail Diretor(a) de Cena
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="E-mail Diretor(a) de Cena"
              fontWeight="500"
              size="md"
              disabled={false}
              value={usuarios[3]?.email}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Telefone Diretor(a) de Cena
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Telefone Diretor(a) de Cena"
              fontWeight="500"
              size="md"
              disabled={false}
              value={usuarios[3]?.telefone}
              as={InputMask}
              mask={mask}
            />
          </FormControl>
        </SimpleGrid>

        <Text
          mt={8}
          fontSize={18}
          color={"#422AFB"}
          fontWeight={"bold"}
          mb={4}
        >
          Locais de Produção
        </Text>

        <Table variant="striped" color="gray.500" mb="24px" mt="12px">
          <Thead>
            <Tr>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #CIDADE
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #ESTADO
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #DIÁRIAS
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #OPÇÕES
                </Flex>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            <Tr key={`insert-item`}>
              <Td
                fontSize={{ sm: "14px" }}
                borderColor="transparent"
                color={"black"}
              >
                <Input
                  isRequired={false}
                  ref={cityRef}
                  fontSize="sm"
                  value={insertCity?.cidade != null ? insertCity.cidade : ""}
                  ms={{ base: "0px", md: "0px" }}
                  type="text"
                  placeholder="Cidade"
                  fontWeight="500"
                  border={"none"}
                  name={`cidade`}
                  size="md"
                  onChange={(e) => {
                    changeCity("cidade", e.target.value);
                  }}
                />
              </Td>
              <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                <Input
                  isRequired={false}
                  fontSize="sm"
                  ms={{ base: "0px", md: "0px" }}
                  type="text"
                  value={insertCity?.estado != null ? insertCity.estado : ""}
                  placeholder="estado"
                  fontWeight="500"
                  border={"none"}
                  name={`estado`}
                  size="md"
                  onChange={(e) => {
                    changeCity("estado", e.target.value);
                  }}
                />
              </Td>
              <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                <Input
                  isRequired={false}
                  fontSize="sm"
                  ms={{ base: "0px", md: "0px" }}
                  type="text"
                  value={
                    insertCity?.diarias != null ? insertCity.diarias : ""
                  }
                  placeholder="diarias"
                  fontWeight="500"
                  border={"none"}
                  name={`diarias`}
                  size="md"
                  onChange={(e) => changeCity("diarias", e.target.value)}
                  onBlur={(e) => {
                    addCity(insertCity);
                  }}
                />
              </Td>
              <Td></Td>
            </Tr>
            {cidades?.map((item, idx) => {
              return (
                <Tr key={`${item.id}-${item}-${idx}`}>
                  <Td
                    fontSize={{ sm: "14px" }}
                    borderColor="transparent"
                    color={"black"}
                  >
                    <Input
                      isRequired={false}
                      fontSize="sm"
                      defaultValue={item.cidade}
                      ms={{ base: "0px", md: "0px" }}
                      type="text"
                      placeholder="qtd"
                      fontWeight="500"
                      border={"none"}
                      name={`cidade-${item.id}`}
                      size="md"
                      onBlur={(e) => {
                        editCity(item, idx, "cidade", e.target.value);
                      }}
                    />
                  </Td>
                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    <Input
                      isRequired={false}
                      fontSize="sm"
                      defaultValue={item.estado}
                      ms={{ base: "0px", md: "0px" }}
                      type="text"
                      placeholder="estado"
                      fontWeight="500"
                      border={"none"}
                      name={`estado-${item.id}`}
                      size="md"
                      onBlur={(e) => {
                        editCity(item, idx, "estado", e.target.value);
                      }}
                    />
                  </Td>
                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    <Input
                      isRequired={false}
                      fontSize="sm"
                      defaultValue={item.diarias}
                      ms={{ base: "0px", md: "0px" }}
                      type="text"
                      placeholder="diarias"
                      fontWeight="500"
                      border={"none"}
                      name={`diarias-${item.id}`}
                      size="md"
                      onBlur={(e) => {
                        editCity(item, idx, "diarias", e.target.value);
                      }}
                    />
                  </Td>
                  <Td>
                    <Button
                      onClick={() => {
                        removeCity(item);
                      }}
                      colorScheme="red"
                      variant="ghost"
                      ml="1"
                    >
                      Excluir
                    </Button>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>

        <Text
          mt={8}
          fontSize={18}
          color={"#422AFB"}
          fontWeight={"bold"}
          mb={4}
        >
          Recursos
        </Text>

        <SimpleGrid columns={4} spacing={4} mt={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Link / Anexo do Tratamento do Diretor(a)
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Link / Anexo do Tratamento do Diretor(a)"
              fontWeight="500"
              size="md"
              disabled={false}
              onBlur={(e) => changeInput("linkDiretor", e.target.value)}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Link pasta Executiva no Drive
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Link pasta Executiva no Drive"
              fontWeight="500"
              size="md"
              disabled={false}
              onBlur={(e) => changeInput("linkDrive", e.target.value)}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Link pasta Finalização no Drive
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Link pasta Finalização no Drive"
              fontWeight="500"
              size="md"
              disabled={false}
              onBlur={(e) => changeInput("linkFinalizacao", e.target.value)}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Link / Anexo do Resumo do Cronograma
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Link / Anexo do Resumo do Cronograma"
              fontWeight="500"
              size="md"
              disabled={false}
              onBlur={(e) => changeInput("linkCronograma", e.target.value)}
            />
          </FormControl>
        </SimpleGrid>

        <SimpleGrid column={1} spacing={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mt={4}
              color={"black"}
            >
              Resumo Cronograma
            </FormLabel>
            <Textarea
              fontSize="sm"
              height={100}
              ms={{ base: "0px", md: "0px" }}
              placeholder="
                PPM Agência:  dd/mm
                PPM Cliente: dd/mm
                Diárias: dd/mm
                Entrega: dd/mm"
              onBlur={(e) => changeInput("resumoCronograma", e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>
        </SimpleGrid>

        <SimpleGrid column={1} spacing={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mt={4}
              color={"black"}
            >
              Notas Internas
            </FormLabel>
            <Textarea
              fontSize="sm"
              height={100}
              ms={{ base: "0px", md: "0px" }}
              placeholder="Notas Internas"
              onBlur={(e) => changeInput("notasInternas", e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>
        </SimpleGrid>

        <Text
          mt={8}
          fontSize={18}
          color={"#422AFB"}
          fontWeight={"bold"}
          mb={4}
        >
          Dados Cliente/Agência
        </Text>

        {accountSelected?.showAgencia && (
          <SimpleGrid columns={5} spacing={2} mt={4}>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"
              >
                Agência
              </FormLabel>

              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size="md"
                onChange={(e) => { }}
                placeholder="Busque a Agência"
                name={"agencia"}
                value={{
                  label: accountSelected?.agencia?.nome,
                  value: accountSelected?.agencia?.id,
                }}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"
              >
                Nome do Contato da Agência
              </FormLabel>
              <Select
                value={contatoAgencia?.id}
                size="md"
                onChange={(e) => { }}
              >
                <option value={contatoAgencia?.id}>
                  {contatoAgencia?.nome}
                </option>
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"
              >
                Email do Contato da Agência
              </FormLabel>

              <Input
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Email do Contato da Agência"
                fontWeight="bold"
                size="md"
                disabled={false}
                value={accountSelected?.contatoAgenciaEmail}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"
              >
                Telefone do Contato da Agência
              </FormLabel>

              <Input
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder=" Telefone do Contato da Agência"
                fontWeight="bold"
                size="md"
                disabled={false}
                value={accountSelected?.contatoAgenciaTelefone}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"
              >
                Cargo do Responsável da Agência
              </FormLabel>

              <Input
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Cargo do Responsável da Agência"
                fontWeight="bold"
                size="md"
                onChange={(e) => { }}
                value={contatoAgencia?.cargo}
              />
            </FormControl>
          </SimpleGrid>
        )}

        <SimpleGrid columns={5} spacing={2} mt={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Cliente
            </FormLabel>

            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size="md"
              placeholder="Busque o Cliente"
              isRequired={true}
              name={"cliente"}
              defaultValue={{
                label: accountSelected?.cliente?.nome,
                value: accountSelected?.cliente?.id,
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Responsável Aprovação Cliente
            </FormLabel>
            <Select value={contatoCliente?.id} size="md">
              <option value={contatoCliente?.id}>
                {contatoCliente?.nome}
              </option>
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Email do Contato do Cliente
            </FormLabel>

            <Input
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder=" Email do Contato do Cliente"
              fontWeight="bold"
              size="md"
              disabled={false}
              value={accountSelected?.contatoClienteEmail}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Telefone do Contato do Cliente
            </FormLabel>

            <Input
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder=" Telefone de Contato do Cliente"
              fontWeight="bold"
              size="md"
              onChange={(e) => { }}
              value={accountSelected?.contatoClienteTelefone}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Cargo do Responsável do Cliente
            </FormLabel>

            <Input
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Cargo do Responsável do Cliente"
              fontWeight="bold"
              size="md"
              onChange={(e) => { }}
              value={contatoCliente?.cargo}
            />
          </FormControl>
        </SimpleGrid>

        <Text
          mt={8}
          fontSize={18}
          color={"#422AFB"}
          fontWeight={"bold"}
          mb={4}
        >
          Contatos Adicionais
        </Text>

        <Table variant="striped" color="gray.500" mb="24px" mt="12px">
          <Thead>
            <Tr>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #NOME
                </Flex>
              </Th>

              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #CARGO
                </Flex>
              </Th>

              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #EMAIL
                </Flex>
              </Th>

              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #TELEFONE
                </Flex>
              </Th>

              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #OPÇÕES
                </Flex>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>
                <FormControl>
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    Nome do Contato
                  </FormLabel>

                  <Input
                    value={
                      insertContact?.nome != null &&
                        insertContact?.tipo === "cliente"
                        ? insertContact?.nome
                        : ""
                    }
                    isRequired={false}
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="Preencha a Nome do Contato"
                    onChange={(e) => {
                      if (e.target.value.length >= 1) {
                        chageTipo("cliente");
                      }
                      changeContact("nome", e.target.value, "cliente");
                    }}
                    fontWeight="500"
                    size="md"
                  />
                </FormControl>
              </Td>
              <Td>
                <FormControl>
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    Cargo do Contato
                  </FormLabel>

                  <Input
                    value={
                      insertContact?.cargo != null &&
                        insertContact?.tipo === "cliente"
                        ? insertContact?.cargo
                        : ""
                    }
                    isRequired={false}
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="Preencha o Cargo do Contato"
                    onChange={(e) =>
                      changeContact("cargo", e.target.value, "cliente")
                    }
                    fontWeight="500"
                    size="md"
                  />
                </FormControl>
              </Td>
              <Td>
                <FormControl>
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    Email do Contato
                  </FormLabel>

                  <Input
                    value={
                      insertContact?.email != null &&
                        insertContact?.tipo === "cliente"
                        ? insertContact?.email
                        : ""
                    }
                    isRequired={false}
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="Preencha o Email do Contato"
                    onChange={(e) =>
                      changeContact("email", e.target.value, "cliente")
                    }
                    fontWeight="500"
                    size="md"
                  />
                </FormControl>
              </Td>
              <Td>
                <FormControl>
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    Telefone do Contato
                  </FormLabel>
                  <Input
                    value={
                      insertContact?.telefone != null &&
                        insertContact?.tipo === "cliente"
                        ? insertContact?.telefone
                        : ""
                    }
                    isRequired={false}
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="Preencha o Telefone"
                    onChange={(e) =>
                      changeContact("telefone", e.target.value, "cliente")
                    }
                    onBlur={(e) => addContact(insertContact)}
                    fontWeight="500"
                    size="md"
                    as={InputMask}
                    mask={mask}
                  />
                </FormControl>
              </Td>
              <Td></Td>
            </Tr>

            {contatoList
              ?.filter((a) => a.tipo === "cliente")
              .map((item, index) => {
                return (
                  <Tr key={`${item.id}-${item}-${index}`}>
                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      <Input
                        defaultValue={item.nome}
                        isRequired={false}
                        fontSize="sm"
                        ms={{ base: "0px", md: "0px" }}
                        type="text"
                        placeholder="Preencha a Nome do Contato"
                        onChange={(e) =>
                          editContact(item, index, "nome", e.target.value)
                        }
                        fontWeight="500"
                        size="md"
                      />
                    </Td>
                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      <Input
                        defaultValue={item.cargo}
                        isRequired={false}
                        fontSize="sm"
                        ms={{ base: "0px", md: "0px" }}
                        type="text"
                        placeholder="Preencha o Cargo do Contato"
                        onChange={(e) =>
                          editContact(item, index, "cargo", e.target.value)
                        }
                        fontWeight="500"
                        size="md"
                      />
                    </Td>

                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      <Input
                        defaultValue={item.email}
                        isRequired={false}
                        fontSize="sm"
                        ms={{ base: "0px", md: "0px" }}
                        type="text"
                        placeholder="Preencha o Email do Contato"
                        onChange={(e) =>
                          editContact(item, index, "email", e.target.value)
                        }
                        fontWeight="500"
                        size="md"
                      />
                    </Td>

                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      <Input
                        defaultValue={item.telefone}
                        isRequired={false}
                        fontSize="sm"
                        ms={{ base: "0px", md: "0px" }}
                        type="text"
                        placeholder="Preencha o Telefone do Contato"
                        onChange={(e) =>
                          editContact(item, index, "telefone", e.target.value)
                        }
                        fontWeight="500"
                        size="md"
                      />
                    </Td>

                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      <Button
                        onClick={() => {
                          removeContact(item);
                        }}
                        colorScheme="red"
                        variant="ghost"
                        ml="1"
                      >
                        Excluir
                      </Button>
                    </Td>
                  </Tr>
                );
              })}
          </Tbody>
        </Table>

        <SimpleGrid column={1} spacing={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              mt={4}
              color={"black"}
            >
              Notas sobre Agência/Cliente
            </FormLabel>
            <Textarea
              fontSize="sm"
              height={100}
              ms={{ base: "0px", md: "0px" }}
              placeholder="Preencha as Notas sobre Agência/Cliente"
              onBlur={(e) => changeInput("notasCliente", e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>
        </SimpleGrid>
        <Text
          mt={8}
          fontSize={18}
          color={"#422AFB"}
          fontWeight={"bold"}
          mb={4}
        >
          Faturamento e Contrato
        </Text>
        <SimpleGrid columns={4} spacing={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Responsável Financeiro
            </FormLabel>

            <Input
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Responsável Financeiro"
              onBlur={
                (e) =>
                  changeRespFinanceiro("nome", e.target.value)
              }
              fontWeight="500"
              size="md"
            />
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Cargo do Responsável Financeiro
            </FormLabel>

            <Input
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Cargo do Responsável Financeiro"
              onBlur={
                (e) =>
                  changeRespFinanceiro("cargo", e.target.value)
              }
              fontWeight="500"
              size="md"
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Email do Responsável Financeiro
            </FormLabel>

            <Input
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o Email do Responsável Financeiro"
              onBlur={
                (e) =>
                  changeRespFinanceiro("email", e.target.value)
              }
              fontWeight="500"
              size="md"
            />
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Telefone do Responsável Financeiro
            </FormLabel>
            <Input
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o Telefone do Responsável Financeiro"
              onBlur={
                (e) =>
                  changeRespFinanceiro("telefone", e.target.value)
              }
              fontWeight="500"
              size="md"
              as={InputMask}
              mask={mask}
            />
          </FormControl>
        </SimpleGrid>

        <SimpleGrid columns={4} spacing={4} mt={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Responsável Jurídico
            </FormLabel>

            <Input
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Responsável Jurídico"
              onBlur={
                (e) =>
                  changeRespJuridico("nome", e.target.value)
              }
              fontWeight="500"
              size="md"
            />
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Cargo do Responsável Jurídico
            </FormLabel>

            <Input
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Cargo do Responsável Jurídico"
              onBlur={
                (e) =>
                  changeRespJuridico("cargo", e.target.value)
              }
              fontWeight="500"
              size="md"
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Email do Responsável Jurídico
            </FormLabel>

            <Input
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o Email do Responsável Jurídico"
              onBlur={
                (e) =>
                  changeRespJuridico("email", e.target.value)
              }
              fontWeight="500"
              size="md"
            />
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Telefone do Responsável Jurídico
            </FormLabel>
            <Input
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o Telefone do Responsável Jurídico"
              onBlur={
                (e) =>
                  changeRespJuridico("telefone", e.target.value)
              }
              fontWeight="500"
              size="md"
              as={InputMask}
              mask={mask}
            />
          </FormControl>
        </SimpleGrid>

        <Text
          mt={8}
          fontSize={18}
          color={"#422AFB"}
          fontWeight={"bold"}
          mb={4}
        >
          Contatos Adicionais
        </Text>

        <Table variant="striped" color="gray.500" mb="24px" mt="12px">
          <Thead>
            <Tr>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #NOME
                </Flex>
              </Th>

              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #CARGO
                </Flex>
              </Th>

              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #EMAIL
                </Flex>
              </Th>

              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #TELEFONE
                </Flex>
              </Th>

              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #OPÇÕES
                </Flex>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>
                <FormControl>
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    Nome do Contato
                  </FormLabel>

                  <Input
                    value={
                      insertContact?.nome != null &&
                        insertContact?.tipo === "financeiro"
                        ? insertContact?.nome
                        : ""
                    }
                    isRequired={false}
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="Preencha a Nome do Contato"
                    onChange={(e) => {
                      if (e.target.value.length >= 1) {
                        chageTipo("financeiro");
                      }
                      changeContact("nome", e.target.value, "financeiro");
                    }}
                    fontWeight="500"
                    size="md"
                  />
                </FormControl>
              </Td>
              <Td>
                <FormControl>
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    Cargo do Contato
                  </FormLabel>

                  <Input
                    value={
                      insertContact?.cargo != null &&
                        insertContact?.tipo === "financeiro"
                        ? insertContact?.cargo
                        : ""
                    }
                    isRequired={false}
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="Preencha o Cargo do Contato"
                    onChange={(e) =>
                      changeContact("cargo", e.target.value, "financeiro")
                    }
                    fontWeight="500"
                    size="md"
                  />
                </FormControl>
              </Td>
              <Td>
                <FormControl>
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    Email do Contato
                  </FormLabel>

                  <Input
                    value={
                      insertContact?.email != null &&
                        insertContact?.tipo === "financeiro"
                        ? insertContact?.email
                        : ""
                    }
                    isRequired={false}
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="Preencha o Email do Contato"
                    onChange={(e) =>
                      changeContact("email", e.target.value, "financeiro")
                    }
                    fontWeight="500"
                    size="md"
                  />
                </FormControl>
              </Td>
              <Td>
                <FormControl>
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    Telefone do Contato
                  </FormLabel>
                  <Input
                    value={
                      insertContact?.telefone != null &&
                        insertContact?.tipo === "financeiro"
                        ? insertContact?.telefone
                        : ""
                    }
                    isRequired={false}
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="text"
                    placeholder="Preencha o Telefone"
                    onChange={(e) =>
                      changeContact("telefone", e.target.value, "financeiro")
                    }
                    onBlur={(e) => addContact(insertContact)}
                    fontWeight="500"
                    size="md"
                    as={InputMask}
                    mask={mask}
                  />
                </FormControl>
              </Td>
              <Td></Td>
            </Tr>

            {contatoList
              ?.filter((a) => a.tipo === "financeiro")
              .map((item, index) => {
                return (
                  <Tr key={`${item.id}-${item}-${index}`}>
                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      <Input
                        defaultValue={item.nome}
                        isRequired={false}
                        fontSize="sm"
                        ms={{ base: "0px", md: "0px" }}
                        type="text"
                        placeholder="Preencha a Nome do Contato"
                        onChange={(e) =>
                          editContact(item, index, "nome", e.target.value)
                        }
                        fontWeight="500"
                        size="md"
                      />
                    </Td>
                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      <Input
                        defaultValue={item.cargo}
                        isRequired={false}
                        fontSize="sm"
                        ms={{ base: "0px", md: "0px" }}
                        type="text"
                        placeholder="Preencha o Cargo do Contato"
                        onChange={(e) =>
                          editContact(item, index, "cargo", e.target.value)
                        }
                        fontWeight="500"
                        size="md"
                      />
                    </Td>

                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      <Input
                        defaultValue={item.email}
                        isRequired={false}
                        fontSize="sm"
                        ms={{ base: "0px", md: "0px" }}
                        type="text"
                        placeholder="Preencha o Email do Contato"
                        onChange={(e) =>
                          editContact(item, index, "email", e.target.value)
                        }
                        fontWeight="500"
                        size="md"
                      />
                    </Td>

                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      <Input
                        defaultValue={item.telefone}
                        isRequired={false}
                        fontSize="sm"
                        ms={{ base: "0px", md: "0px" }}
                        type="text"
                        placeholder="Preencha o Telefone do Contato"
                        onChange={(e) =>
                          editContact(item, index, "telefone", e.target.value)
                        }
                        fontWeight="500"
                        size="md"
                      />
                    </Td>

                    <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                      <Button
                        onClick={() => {
                          removeContact(item);
                        }}
                        colorScheme="red"
                        variant="ghost"
                        ml="1"
                      >
                        Excluir
                      </Button>
                    </Td>
                  </Tr>
                );
              })}
          </Tbody>
        </Table>

        <SimpleGrid columns={2} spacing={4} mt={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Dados de Faturamento
            </FormLabel>

            <Box w={"88%"}>
              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size="md"
                onChange={(e) => {
                  changeFaturamento(e.value)
                }}
                placeholder="Busque os Dados de Faturamento"
                isRequired={true}
                name={"faturamento"}
                options={clients?.map((item) => {
                  return {
                    label: item.nome,
                    value: item.id,
                  };
                })}
                defaultValue={{
                  label: faturamento?.nome,
                  value: faturamento?.id
                }}
              />
            </Box>

            <IconButton
              colorScheme="brand"
              variant="solid"
              mt={-10}
              borderRadius={8}
              mr={12}
              icon={<MdAdd />}
              onClick={() => {
                showFormPessoa(true);
              }}
              float={"right"}
              aria-label={"Adicionar Cliente"}
            />
            <IconButton
              colorScheme="brand"
              variant="solid"
              mt={-10}
              borderRadius={8}
              icon={<MdEdit />}
              onClick={() => {
                editPessoa(faturamento)
              }}
              float={"right"}
              aria-label={"Editar Contato"}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Dados para Contrato
            </FormLabel>

            <Box w={"88%"}>
              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size="md"
                onChange={(e) => {
                  changeContrato(e.value)
                }}
                placeholder="Busque os Dados para Contrato"
                isRequired={true}
                name={"contrato"}
                options={clients?.map((item) => {
                  return {
                    label: item.nome,
                    value: item.id,
                  };
                })}
                defaultValue={{
                  label: contrato?.nome,
                  value: contrato?.id
                }}
              />
            </Box>

            <IconButton
              colorScheme="brand"
              variant="solid"
              mt={-10}
              borderRadius={8}
              mr={12}
              icon={<MdAdd />}
              onClick={() => {
                showFormPessoa(true);
              }}
              float={"right"}
              aria-label={"Adicionar Cliente"}
            />
            <IconButton
              colorScheme="brand"
              variant="solid"
              mt={-10}
              borderRadius={8}
              icon={<MdEdit />}
              onClick={() => {
                editPessoa(contrato)
              }}
              float={"right"}
              aria-label={"Editar Contato"}
            />
          </FormControl>
        </SimpleGrid>
        <SimpleGrid column={1} spacing={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              mt={4}
              color={"black"}
            >
              Instruções sobre Faturamento e Contrato
            </FormLabel>
            <Textarea
              fontSize="sm"
              height={100}
              ms={{ base: "0px", md: "0px" }}
              placeholder="Preencha as Instruções sobre Faturamento e Contrato"
              onBlur={(e) => changeInput("instrucaoContrato", e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>
        </SimpleGrid>

        <Text
          mt={8}
          fontSize={18}
          color={"#422AFB"}
          fontWeight={"bold"}
          mb={4}
        >
          Recuros e informações adicionais
        </Text>

        <SimpleGrid columns={4} spacing={4} mt={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={"black"}
              mb="8px"
            >
              Link de PO, Ficha de cadastro ou Arquivo Relevante
            </FormLabel>

            <Input
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Link de PO, Ficha de cadastro ou Arquivo Relevante"
              fontWeight="500"
              size="md"
              disabled={false}
              onChange={(e) => changeInput("linkPO", e.target.value)}
            />
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Modelo de Negócio
            </FormLabel>

            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size="md"
              placeholder="Busque o Modelo de Negócio"
              name={"modelo negocio"}
              value={{
                label: accountSelected?.modeloNegocio?.nome,
                value: accountSelected?.modeloNegocio?.id,
              }}
            />
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Condição de Pagamento
            </FormLabel>

            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size="md"
              placeholder="Busque a Forma de Pagamento"
              name={"formaPagametno"}
              value={{
                label: accountSelected?.condicaoPagamento?.nome,
                value: accountSelected?.condicaoPagamento?.id,
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Total Orçamento
            </FormLabel>
            <NumberInput
              precision={0}
              step={10000}
              min={0}
              isDisabled
              value={formatNumber(accountState?.totalOrder)}
              onChange={(e: string) => { }}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>
        </SimpleGrid>

        <Text
          mt={8}
          fontSize={18}
          color={"#422AFB"}
          fontWeight={"bold"}
          mb={4}
        >
          Carta de Orçamento Enviada
        </Text>
        <JoditEditor
          ref={editor}
          value={accountSelected?.carta}
          config={{
            buttons: [
              "source",
              "|",
              "bold",
              "strikethrough",
              "underline",
              "italic",
              "|",
              "ul",
              "ol",
              "|",
              "outdent",
              "indent",
              "|",
              "font",
              "fontsize",
              "brush",
              "paragraph",
              "|",
              "image",
              "video",
              "table",
              "link",
              "|",
              "align",
              "undo",
              "redo",
              "|",
              "hr",
              "eraser",
              "copyformat",
              "|",
              "symbol",
              "fullsize",
              "print",
              "about",
            ],
            buttonsXS: [
              "bold",
              "image",
              "|",
              "brush",
              "paragraph",
              "|",
              "align",
              "|",
              "undo",
              "redo",
              "|",
              "eraser",
              "dots",
            ],
            readonly: false,
          }}
          onBlur={(newContent) => {
            //
          }}
        />
      </Box>
    </Box>
  );
};
export default LaunchProjectForm;
